// removed by extract-text-webpack-plugin
module.exports = {"Main":"src-containers-List-__ListPage-module___Main"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/List/ListPage.module.css
// module id = 1210
// module chunks = 1